/* dm-lux.js : presentation helpers for the Desk Layer Co "Aurora" design. No libraries, no scroll listeners.
   1 reveal on enter ([data-reveal], staggered with --i in CSS)  2 native <details name> fallback  3 [data-lux-open] opens a details
   4 keyboard access for horizontal swipe rows (.lux-swipe)  5 site-wide sticky bar waits for the hero CTA to scroll past
   All behavior (cart, drawers, header, product form, sticky bar) stays in dm-global.js / dm-cart.js / dm-product.js.
   Progressive enhancement: with JS off the page is fully visible (hidden reveal states exist only under html.lux-js). */
(function () {
  'use strict';
  var doc = document;
  var root = doc.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;
  function $$(s, c) { return [].slice.call((c || doc).querySelectorAll(s)); }

  /* 1 reveal */
  var revealIO = null;
  /* once the reveal transition is over, drop the hook so the element's own transitions (hover lifts, etc.) apply again */
  function settle(el) {
    var ms = 1200;
    try { ms += (parseFloat(getComputedStyle(el).transitionDelay) || 0) * 1000; } catch (x) {}
    setTimeout(function () { el.removeAttribute('data-reveal'); }, ms);
  }
  function observe(el) {
    if (el.classList.contains('is-in')) { return; }
    if (!revealIO) { el.classList.add('is-in'); } else { revealIO.observe(el); }
  }
  if (hasIO && !reduce && !(window.Shopify && window.Shopify.designMode)) {
    revealIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); settle(e.target); revealIO.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
  } else {
    root.classList.add('lux-reveal-all');
  }
  $$('[data-reveal]').forEach(observe);
  /* sections added later (theme editor, quick views) */
  doc.addEventListener('shopify:section:load', function (e) {
    $$('[data-reveal]', e.target).forEach(function (el) { el.classList.add('is-in'); });
  });

  /* 2 native <details name> is exclusive in modern browsers; close siblings by hand where it is not */
  if (!('name' in doc.createElement('details'))) {
    $$('details[name]').forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) { return; }
        $$('details[name="' + d.getAttribute('name') + '"]').forEach(function (o) { if (o !== d) { o.open = false; } });
      });
    });
  }

  /* 3 links with data-lux-open="#id" open that <details> on click */
  $$('[data-lux-open]').forEach(function (a) {
    a.addEventListener('click', function () {
      var t = doc.querySelector(a.getAttribute('data-lux-open'));
      if (t && t.tagName === 'DETAILS') { t.open = true; }
    });
  });

  /* 4 swipe rows must be reachable by keyboard (axe: scrollable-region-focusable) */
  $$('.lux-swipe').forEach(function (el) {
    if (!el.hasAttribute('tabindex')) { el.setAttribute('tabindex', '0'); }
  });

  /* 5 site-wide sticky bar: on a page with a hero it waits until the hero's own call to action has scrolled past
     (html.lux-cta-in = that button is on screen or still ahead). No hero, no observer or no JS = the bar is always shown. */
  var heroCta = doc.querySelector('.lux-hero .lux-actions__go');
  if (heroCta && hasIO) {
    new IntersectionObserver(function (entries) {
      var e = entries[entries.length - 1];
      root.classList.toggle('lux-cta-in', e.isIntersecting || e.boundingClientRect.top > 0);
    }).observe(heroCta);
  }
})();
